<template>
    <VaLayout  
      style="height: 100%; min-height: 100vh;"
      :left="{ absolute: $vaBreakpoint.smDown }"
    >

      <template #top>
        <VaNavbar color="color1"  class="py-2" gradient>
          <template #left>
            <VaButton :icon="store.state.ui.showSidebar ? 'menu_open' : 'menu'" @click="store.state.ui.showSidebar = !store.state.ui.showSidebar" color="color1"/>
          </template>
          <template #center>
            <VaNavbarItem class="font-bold text-lg">
                <h1 class="text-center font-bold text-2xl md:text-4xl py-5">{{useRouter().currentRoute.value.meta.routeTitle}}</h1>
            </VaNavbarItem>
          </template>
        </VaNavbar>
      </template>
  
      <template #left>
        <PanelSidebar class="col-span-1" />

      </template>
  
      <template #content>
        <main class="p-4 ">
          <slot/>
        </main>
      </template>
    </VaLayout>
  </template>

<script setup lang="ts">
import { onUpdated, ref } from 'vue';
import {useStoreKey} from '@/store'
import { useRouter } from 'vue-router';
import { useBreakpoint } from 'vuestic-ui/web-components';
import { useStore } from '@/store';
import PanelSidebar from '@/components/utils/PanelSidebar.vue';
const store = useStore();

</script>